module.exports = __webpack_public_path__ + "images/yes-c0341dc68d408fa6f15a5b7874d792e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/components/Classify/images/yes.png
// module id = 414
// module chunks = 3